<template>
  <div class="md-layout">
    <YvIndex
      ref="allListTable"
      :path="path"
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :disabledHeaderActions="true"
      :sortable="sortable"
      :tableActionsComponent="TableActions"
      :formatTableData="formatTableData"
    >
    </YvIndex>
  </div>
</template>
<script>
import YvIndex from "@/components/Base/YvIndex";
import TableActions from "./TableActions";
import { DEFAULT_OPTION_ALL } from "@/constants";
import { service_names } from "@/constants/Services";
import Swal from "sweetalert2";
import { getId, Message } from "@/helpers/utils";
import { convertDateFromServer } from "@/helpers/datetime-helper";
import { generateStatus } from "../../../helpers/text-helper";

export default {
  components: {
    YvIndex
  },
  data() {
    return {
      MAIN_TASK: "main-task",
      INDIVIDUAL: "individual",
      TableActions,
      path: `${service_names.school}/task-managements`,
      formSearch: [
        {
          label: "task_management.title",
          name: "title",
          value: "",
          type: "input",
          width: 33
        },
        {
          label: "task_management.type",
          name: "type",
          value: "",
          type: "select",
          options: [
            ...DEFAULT_OPTION_ALL,
            { id: "main-task", name: "task_management.main_task" },
            { id: "individual", name: "task_management.individual_task" }
          ],
          width: 33
        },
        {
          label: "common.status",
          name: "task_status_id",
          value: "",
          type: "select",
          options: [...DEFAULT_OPTION_ALL],
          width: 33
        },
        {
          label: "task_management.created_time",
          name: "sent_date",
          value: [],
          type: "date-range",
          width: 33
        },
        {
          label: "task_management.owner",
          name: "owner_id",
          value: "",
          fields: {
            text: "name",
            value: "id"
          },
          type: "autocomplete",
          options: [],
          refetchOptions: this.fetchOwner,
          searchKey: "search_key",
          width: 33
        },
        {
          label: "task_management.assignee",
          name: "assignee_id",
          value: "",
          fields: {
            text: "name",
            value: "id"
          },
          type: "autocomplete",
          options: [],
          refetchOptions: this.fetchStaff,
          searchKey: "full_name_or_staff_code",
          width: 33
        }
      ],
      columns: {
        project_name: "task_management.title",
        taskType: "task_management.type",
        status: "common.status",
        subtaskName: "task_management.subtasks",
        createdTime: "task_management.created_time",
        owner: "task_management.owner"
      },
      sortable: ["project_name"]
    };
  },
  created() {
    this.fetchOwner();
    this.fetchStaff();
    this.fetchStatus();
  },
  methods: {
    fetchStatus() {
      this.$axios
        .get(`${service_names.school}/task-status`)
        .then(({ data }) => {
          if (data.data.length) {
            data.data.forEach(status => {
              status.name = generateStatus(status.name);
            });
            this.formSearch[2].options = [
              ...this.formSearch[2].options,
              ...data.data
            ];
          }
        });
    },
    fetchStaff(param) {
      return this.$axios
        .get(
          `${service_names.user}/staffs`,
          param,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(res => {
          let assignee = this.formSearch.find(
            item => item.name === "assignee_id"
          );
          assignee.options = res.data.data.map(item => ({
            id: getId(item),
            name: item.full_name + " - " + item.staff_code
          }));
        });
    },
    fetchOwner(param) {
      return this.$axios
        .get(
          `${service_names.school}/task-managements/owner`,
          param,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(res => {
          let owner = this.formSearch.find(item => item.name === "owner_id");
          owner.options = res.data.data.map(item => ({
            id: getId(item),
            name: item.full_name + " - " + item.staff_code
          }));
        });
    },
    formatTableData(data) {
      return data.map(item => {
        item.taskType =
          item.type === this.MAIN_TASK
            ? `<div class="text-[#007AFF]">${this.$t(
                "task_management.main_task"
              )}</div>`
            : `<div class="text-[#4CAF50]">${this.$t(
                "task_management.individual_task"
              )}</div>`;
        item.status = generateStatus(item.status);
        item.subtaskName =
          item.subtasks.length && this.generateSubtasks(item.subtasks);
        item.createdTime = convertDateFromServer(item.created_at, "date");
        item.owner = item.full_name;
        return item;
      });
    },
    generateSubtasks(subtasks) {
      if (subtasks.length > 1) {
        let strSubtask = "";
        subtasks.map((task, index) => {
          strSubtask += `<p class="mb-2">${index + 1}. <a href="/sub-task/${
            task.id
          }" target="_blank">${task.task_name}</a></p>`;
        });
        return strSubtask;
      } else {
        return `<a href="/sub-task/${subtasks[0].id}" target="_blank">${subtasks[0].task_name}</a>`;
      }
    },
    async confirmDelete(item) {
      let allowDeleteMainTask = false;
      if (item.type === this.MAIN_TASK) {
        allowDeleteMainTask = await this.$axios
          .get(`${service_names.school}/main-task/${item.id}`)
          .then(res => {
            return res.data.subtasks.every(
              subtask => subtask.sub_task_status?.name === "assigned"
            );
          });
      }
      if (item.type === this.INDIVIDUAL || allowDeleteMainTask) {
        Swal.fire({
          title: this.$t("common.are_you_sure"),
          text: this.$t("task_management.delete_title"),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success btn-fill",
          cancelButtonClass: "md-button md-danger btn-fill",
          confirmButtonText: this.$t("common.yes_delete_it"),
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.deleteTask(item);
          }
        });
      } else {
        Message.error(this.$t("task_management.not_allow_delete"));
      }
    },
    deleteTask(item) {
      let path =
        item.type === this.MAIN_TASK
          ? `${service_names.school}/main-task/${item.id}`
          : `${service_names.school}/sub-task/${item.id}`;
      this.$axios.delete(path).then(() => {
        Message.success(this.$t("common.delete_success"));
        this.$refs.allListTable.getTableData();
      });
    }
  },
  provide() {
    return {
      confirmDelete: this.confirmDelete
    };
  }
};
</script>
